import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEOHead({ title, description, url, lang = 'en' }) {
  const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
  const GA4_ID = process.env.REACT_APP_GA4_ID;

  useEffect(() => {
    // GA4 pageview
    if (window.gtag) window.gtag('event', 'page_view', { page_location: window.location.href });
    // Pixel pageview
    if (window.fbq) window.fbq('track', 'PageView');
  }, [url]);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={url} />
      {PIXEL_ID && (
        <script>{`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${PIXEL_ID}');fbq('track','PageView');`}</script>
      )}
      {GA4_ID && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`} />
      )}
      {GA4_ID && (
        <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA4_ID}');`}</script>
      )}
    </Helmet>
  );
}

export function fireLeadEvent(service) {
  const eventName = `lead_${service.replace(/[^a-z]/g, '_')}`;
  if (window.fbq) window.fbq('track', 'Lead', { content_name: service });
  if (window.gtag) window.gtag('event', 'generate_lead', { event_category: 'lead', event_label: service, custom_event: eventName });
}
